import { SET_ALERT_ACTION } from "./reducersConstants";

export const setAlertAction = (fail, success, code, message, text) => {
  return {
    type: SET_ALERT_ACTION,
    showFail: fail,
    showSuccess: success,
    code,
    message,
    text,
  };
};

const initialState = {
  showFail: false,
  showSuccess: false,
  code: "",
  message: "",
  text: "",
};

export const alertReducer = (previousState = initialState, { type, showFail, showSuccess, code, message, text }) => {
  switch (type) {
    case SET_ALERT_ACTION:
      return { ...previousState, showFail, showSuccess, code, message, text };
    default:
      return previousState;
  }
};
